import { Field, useFormikContext } from 'formik';
import React, { FC } from 'react';
import { WizardStepLayout } from '../../../wizard/wizard-summary-layout';
import { TYPE_ENTRY_AND_EXIT, TYPE_ENTRY_ONLY } from "../../../../constants/install-device";
import { useLocale } from '../../../../contexts/localeContext';
import { TranslationKeys } from '../../../../contexts/TranslationKeys';
import { Controller } from '../../../../models/Controller';
import Label from '../../../label/label';

interface DoorCreationProps {
    setSelectedDevice: React.Dispatch<React.SetStateAction<Controller>>;
    onNext: (e) => void;
    onBack: (e) => void;
}

const DoorCreation: FC<DoorCreationProps> = ({ onNext, onBack, setSelectedDevice }) => {
    const { translate } = useLocale();
    const { setFieldValue, values } = useFormikContext<any>();

    const onAutoDoorCreation = (event) => {
        const isChecked = event.target.checked;
        setFieldValue("autoCreateDoors", isChecked)
    }

    const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;

        if (value === TYPE_ENTRY_ONLY) {
            setFieldValue("autoCreateDoorsType", TYPE_ENTRY_ONLY);
        }
        else if (value === TYPE_ENTRY_AND_EXIT) {
            setFieldValue("autoCreateDoorsType", TYPE_ENTRY_AND_EXIT);
        }
    }

    const handleOnNext = (e) => {
        setSelectedDevice((selectedDevice) => ({
            ...selectedDevice,
            autoCreateDoors: values.autoCreateDoors,
            autoCreateDoorsType: values.autoCreateDoorsType
        }));
        onNext(e);
    }

    return (
        <WizardStepLayout onBack={onBack} onNext={handleOnNext}>
            <label className='text-lg font-bold'>{translate.byKey(TranslationKeys.doorCreation)}</label>
            <div className="flex flex-row mb-1 mt-2">
                <Field
                    id={`checkbox-autoCreateDoors`}
                    type="checkbox"
                    name="autoCreateDoors"
                    checkbox={values.autoCreateDoors}
                    onChange={onAutoDoorCreation} />
                <Label htmlFor={`checkbox-autoCreateDoors`} className="ml-2">{translate.byKey(TranslationKeys.automaticallyCreateNewDoor)}</Label>
            </div>
            <div className="flex flex-col pl-6">
                <div className="justify-start mb-1">
                    <Field type="radio" name="autoCreateDoorsType" id="entryReaderOnly"
                        defaultChecked={true}
                        value={TYPE_ENTRY_ONLY}
                        onChange={handleRadioChange}
                        disabled={!values.autoCreateDoors} />
                    <span className="ml-2">{translate.byKey(TranslationKeys.entryReaderOnly)}</span>
                </div>
                <div className="justify-start">
                    <Field type="radio" name="autoCreateDoorsType" id="exitAndEntryReaders"
                        value={TYPE_ENTRY_AND_EXIT}
                        onChange={handleRadioChange}
                        disabled={!values.autoCreateDoors} />
                    <span className="ml-2">{translate.byKey(TranslationKeys.exitAndEntryReaders)}</span>
                </div>
            </div>
        </WizardStepLayout>
    );
}

export default DoorCreation;
